import React from "react";
import { Button } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";

import AiDraftAssistant, { assistantLabels } from "../AiDraftAssistant";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const NEW_SUGGESTION_KEYS = ["s1", "s2", "s3"];
const REVIEW_SUGGESTION_KEYS = ["review", "shorter", "transfer"];

const PromptBuilderDialog = ({ open, onClose, onApply, promptId, type, initialText = "" }) => {
  const hasPrompt = Boolean(initialText.trim());

  const ask = async body => (await api.post("/prompt/builder", { ...body, promptId, type })).data;

  return (
    <AiDraftAssistant
      open={open}
      onClose={onClose}
      title={i18n.t(hasPrompt ? "promptBuilder.improveTitle" : "promptBuilder.createTitle")}
      initialText={initialText}
      draftFormat="markdown"
      labels={assistantLabels("promptBuilder")}
      suggestions={(hasPrompt ? REVIEW_SUGGESTION_KEYS : NEW_SUGGESTION_KEYS).map(key =>
        i18n.t(`promptBuilder.suggestions.${key}`)
      )}
      onAsk={ask}
      topBarContent={({ text, busy }) => (
        <>
          <span style={{ flex: 1 }} />
          <Button
            variant="contained"
            startIcon={<CheckOutlinedIcon />}
            onClick={() => onApply(text)}
            disabled={busy || !text.trim() || text.trim() === initialText.trim()}
          >
            {i18n.t("promptBuilder.apply")}
          </Button>
        </>
      )}
    />
  );
};

export default PromptBuilderDialog;
